// Runtime constants (for validation)
export const MEAL_TYPES = ['loss', 'maintenance', 'reward'];
export const MEAL_SLOTS = [
    'breakfast',
    'morning_snack',
    'lunch',
    'afternoon_snack',
    'dinner',
    'evening_snack',
];
export const SNACK_SLOTS = [
    'morning_snack',
    'afternoon_snack',
    'evening_snack',
];
export const REQUIRED_MEAL_SLOTS = [
    'breakfast',
    'lunch',
    'dinner',
];
// Optional enum-like objects if you prefer IsEnum over IsIn
export const MealTypeEnum = {
    loss: 'loss',
    maintenance: 'maintenance',
    reward: 'reward',
};
export const MealSlotEnum = {
    breakfast: 'breakfast',
    morning_snack: 'morning_snack',
    lunch: 'lunch',
    afternoon_snack: 'afternoon_snack',
    dinner: 'dinner',
    evening_snack: 'evening_snack',
};
export function isSnackSlot(slot) {
    return SNACK_SLOTS.includes(slot);
}
export function isRequiredMealSlot(slot) {
    return REQUIRED_MEAL_SLOTS.includes(slot);
}
